// Which chat to show after one is deleted: the current one stays unless it was
// the one deleted, then the newest remaining chat, or a new chat (null).
export const nextChatAfterDelete = (
  chats: ReadonlyArray<{ id: string }>,
  deletedId: string,
  currentId: string | null,
): string | null => {
  if (currentId !== deletedId) return currentId;

  return chats.find((chat) => chat.id !== deletedId)?.id ?? null;
};
